// These are the URLs that are used in the product subscription sign up page so that,
// after a successful self-subscribe attempt, we can offer customers a way to schedule a
// call with an onboarder.
export const ONBOARDER_SCHEDULING_URLS = {
  ONLINE_SCHEDULING: 'https://getweave.chilipiper.com/book/upsell?type=64ff8c1d1c5178020e8bb297&back=true',
  PRACTICE_ANALYTICS: 'https://getweave.chilipiper.com/book/upsell?type=652829d5d593786d70b20303&back=true',
  FORMS: 'https://getweave.chilipiper.com/book/upsell?type=64ff89461c5178020e8bb181&back=true',
};
